<script setup lang="ts">

import { Faq, BatteryVoltage, PairingOptions, ScanHistory } from ".";
import { useViewModelInstance } from "../..";
import { useBackButton } from "@app/Components/Utilities";
import { HealthMonitor } from "@app/MyGarage/Components/HealthMonitor";

useBackButton();

const model = await useViewModelInstance();
const healthMonitor = model.carePlan.healthMonitor;

</script>

<template>

    <div class="bg-white dark:bg-gray-900
                  text-sm lg:text-base tracking-wider
                  w-full h-full overflow-y-auto flex flex-col
                  bg-gradient-to-b from-gray-900 via-20% via-gray-850 to-gray-900">

        <div>
            <div class="bg-gradient-to-b dark:from-transparent via-75%
                        dark:via-gray-900/60 dark:to-gray-850 pb-6 lg:pb-8">

                <div class="flex justify-center items-center my-6">
                    <strong class="text-lg font-bold">
                        24/7 Live Health Monitor
                    </strong>
                </div>

                <HealthMonitor v-model="healthMonitor"
                               :feature="model.carePlan.healthMonitor" />

            </div>

            <!-- HEALTH MONITOR IS NOT INSTALLED -->
            <Faq v-if="healthMonitor.isInstalled == false" />

            <!-- HEALTH MONITOR IS INSTALLED BUT NOT PAIRED -->
            <PairingOptions v-else-if="healthMonitor.isPaired == false" />

            <!-- HEALTH MONITOR IS INSTALLED AND PAIRED -->
            <div v-else class="h-full flex flex-col flex-1">

                <!-- BATTERY HEALTH INDICATOR HAS DATA -->
                <div v-if="healthMonitor.batteryHealth.hasData">
                    <BatteryVoltage v-model="healthMonitor" />
                </div>

                <ScanHistory :vehicleId="model.vehicle.vehicleId" />

            </div>
        </div>

    </div>

</template>
